import { defineStore } from 'pinia'

type TStoreState = {
    fontsReady?: number,
    animate: boolean,
    title: string | undefined,
    classes: string | undefined,
    domain: string | undefined,
    dimensions: {}
};

export const useAnimatedTitleStore = defineStore('animated-title', {
  state: (): TStoreState => {
    return {
      fontsReady: undefined,
      animate: false,
      title: undefined,
      classes: undefined,
      domain: undefined,
      dimensions: {}
    }
  },
  actions: {
    clear () {
      this.$state.animate = false
      this.$state.title = ''
      this.$state.classes = ''
      this.$state.domain = ''
      this.$state.dimensions = {}
    },
    listenForFontsLoaded () {
      // safari
      document.fonts.ready.then(() => {
        window.requestAnimationFrame(() => {
          if (!this.$state.fontsReady) {
            this.$state.fontsReady = new Date().getTime()
          }
        })
      })

      // chrome
      document.fonts.onloadingdone = () => {
        window.requestAnimationFrame(() => {
          if (!this.$state.fontsReady) {
            this.$state.fontsReady = new Date().getTime()
          }
        })
      }
    }
  }
})
